export default __webpack_public_path__ + "static/media/placeholder-platinum-cover.d045d840.svg";